





import Vue from 'vue'

export default Vue.extend({
  name: 'PrivateCellRenderer',

  props: {
    isPrivate: Boolean,
  },

  computed: {
    icon (): string {
      return this.isPrivate ? 'check' : 'clear'
    },

    color (): string {
      return this.isPrivate ? 'green' : 'red'
    }
  }
})
